<!-- @format -->

<ng-template #descriptionBody>
	<div>
		@for (item of highlyRatedForFeatures$ | async; track $index; let first = $first, last = $last;) {
			<div [ngClass]="{
				'hmf-mt-s': !isMobile && first
			}">
				<p class="hmf-display-flex hmf-body-bold-l hmf-mb-xxs hover-pointer">
					{{ item.feature | titlecase }}
				</p>
				@if (item['_embedded']?.quotes?.length > 0) {
					<p class="hmf-body-m hmf-mb-0" [innerHTML]="item['_embedded'].quotes[0].text | boldSpan:item.feature | bypassSanitization"></p>
				}
			</div>
			<div class="label-base-subtle hmf-mt-xxxs"
				[ngClass]="{
					'hmf-mb-xs': last,
					'hmf-mb-s': !last
				}">
				<button
					hmf-action-text
					variant="secondary"
					size="small"
					(click)="openReviewsDrawer({
						feature: item.feature,
						type: proFeatureType
					})">
					<span class="hmf-body-s">
						View reviews that mention {{ item | featureLabel | titlecase }}
					</span>
				</button>
			</div>
		}
	</div>
</ng-template>

@if (isMobile) {
	<hmf-drawer
		#drawer
		[isCloseButtonSticky]="true"
		headerText="Customer Highlighted"
		direction="bottom">
		<div class="highly-rated-for-drawer-content hmf-px-s hmf-pb-s scrollable hmf-w-100">
			<ng-container *ngTemplateOutlet="descriptionBody"></ng-container>
		</div>
	</hmf-drawer>
} @else {
	<hmf-modal
		#modal
		[ngClass]="{
			'modal-open': isModalOpen
		}"
		[headerText]="'Customer Highlighted'"
		[type]="'modal'"
		[closable]="true"
		[showHeaderBottomBorder]="false"
		[focus]="true"
		[interactability]="false"
		[clickableBackground]="false"
		(opened)="isModalOpen = true"
		(closed)="isModalOpen = false">
		<div class="highly-rated-for-modal-content hmf-align-items-center hmf-m-m">
			<div class="hmf-mt-0">
				<p class="hmf-header-bold-m hmf-mr-l">Customer Highlighted</p>
			</div>
			<ng-container *ngTemplateOutlet="descriptionBody"></ng-container>
		</div>
	</hmf-modal>
}
